export default __webpack_public_path__ + "static/media/kia.1b2f583e.jpg";